import {useSelector} from 'react-redux';
import * as css from './timetableSales.css';
import useMobile from '../../../../../hooks/useMobile';
import {useTimetableSalesData} from './useTimetableSalesData';
import TimetableSalesTemplate from './timetableSalesTemplate';
import TimetableSalesHeader from './components/TimetableSalesHeader/TimetableSalesHeader';
import TimetableSalesSummary from './components/TimetableSalesSummary/TimetableSalesSummary';
import LecturesBoard from './components/LecturesBoard/LecturesBoard';
import LecturesEmpty from './components/LecturesEmpty/LecturesEmpty';

function TimetableSales() {
    const eid = useSelector((s: any) => s.event.eid);
    const {data, summary, showSkeleton, timeGroups} = useTimetableSalesData(eid);
    const isMobile = useMobile();

    if(showSkeleton) return <TimetableSalesTemplate />;
    if(!data) return null;

    const hasLectures = !!data.lectures?.length;

    return (
        <css.container>
            <TimetableSalesHeader eid={eid} />
            {hasLectures && summary && <TimetableSalesSummary summary={summary} isMobile={isMobile} />}
            {timeGroups.length > 0 ? <LecturesBoard timeGroups={timeGroups} /> : <LecturesEmpty />}
        </css.container>
    );
}
export default TimetableSales;
